import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
	private http = inject(HttpClient);
	private platformId = inject(PLATFORM_ID);

	getTranslation(lang: string): Observable<Translation> {
		if (isPlatformServer(this.platformId)) {
			// On server, read directly from filesystem
			return new Observable((observer) => {
				try {
					const fs = require('node:fs');
					const path = require('node:path');

					// Try production path first, then development path
					const possiblePaths = [
						path.join(process.cwd(), 'dist/browser/assets/i18n', `${lang}.json`),
						path.join(process.cwd(), 'src/assets/i18n', `${lang}.json`),
					];

					let translationData = null;
					for (const translationsPath of possiblePaths) {
						if (fs.existsSync(translationsPath)) {
							translationData = JSON.parse(fs.readFileSync(translationsPath, 'utf8'));
							break;
						}
					}

					if (translationData) {
						observer.next(translationData);
					} else {
						// Return empty object if file not found
						observer.next({});
					}
					observer.complete();
				} catch {
					// Return empty object on error
					observer.next({});
					observer.complete();
				}
			});
		}

		// On browser, use HTTP request
		return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
	}
}
